import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const MedicationAllergies = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("MedicationAllergiesQuestion", value);
    props.handleStepData("MedicationAllergies", "");
    if (value === "No") {
      setLastUpdate({ key: "MedicationAllergiesQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col gap-4">
      <p className="pb-6 font-serif text-h3">
        Do you have any medication allergies?
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.MedicationAllergiesQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div hidden={props.data.MedicationAllergiesQuestion !== "Yes"}>
        <TextArea
          label="List allergies"
          value={props.data.MedicationAllergies as string}
          onChange={(value) =>
            props.handleStepData("MedicationAllergies", value)
          }
          invalid={!!props.errors?.MedicationAllergies}
        />
        <div hidden={!props.errors?.MedicationAllergies}>
          <p className="mt-2 text-sm text-red">
            Please list your medication allergies.
          </p>
        </div>
      </div>
      <div
        hidden={props.data.MedicationAllergiesQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
